import { render, staticRenderFns } from "./AwardView.vue?vue&type=template&id=5d241784"
import script from "./AwardView.vue?vue&type=script&lang=ts"
export * from "./AwardView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports